// Universal Scripting
// Media ------------------------------------

// Custom video button - scoped to closest video in the same parent element
document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rev-play');
    if (!btn) return;
    const wrap = btn.closest('.rev-media');
    if (!wrap) return;
    const video = wrap.querySelector('video');
    if (!video) return;
    if (!video.hasAttribute('controls')) video.setAttribute('controls', 'controls');
    try { video.muted = false; } catch (_) { }
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => { /* ignore autoplay-policy errors */ });
    btn.style.display = 'none';
    video.addEventListener('ended', function handleEnd() {
        video.removeAttribute('controls');
        btn.hidden = false;
        video.currentTime = 0;
        video.pause();
        video.removeEventListener('ended', handleEnd);
    }, { once: true });
}, { passive: true });